import qs from 'qs';
import HeaderApi from '@services/HeaderApi';
import isOnReferrals from './isOnReferrals';

export const signInStatus = (() => {
  let _isSignedIn = false;

  function setSignedIn(status) {
    _isSignedIn = status;
  }

  function isSignedIn() {
    return _isSignedIn;
  }

  return {
    setSignedIn,
    isSignedIn
  };
})();

export const removeQueryParam = (paramName = '') => {
  if (typeof window === 'undefined') return;

  const currentParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const remainingParams = Object.keys(currentParams).reduce((acc, paramKey) => {
    const isAccountParam = paramKey === paramName;
    return isAccountParam
      ? acc
      : { ...acc, [paramKey]: currentParams[paramKey] };
  }, {});
  const paramString = qs.stringify(remainingParams, { addQueryPrefix: true });
  const relativeUrlWithParamString = window.location.pathname + paramString;
  window.history.replaceState({}, document.title, relativeUrlWithParamString);
};


const refreshHeader = () => {
  removeQueryParam('openAccountModal');
  window.location.reload();
};

const redirectOnLogin = redirectUrl => {
  window.location.href = redirectUrl;
};

export const afterSignInSuccess = async () => {
  try {
    if (isOnReferrals()) return refreshHeader();

    const urlParams = new URLSearchParams(window.location.search);
    // NOTE --  adding "returnUrl" query parameter with value will redirect

    const returnUrl = urlParams.get('returnUrl') ?? urlParams.get('ReturnUrl');
    if (returnUrl) return redirectOnLogin(returnUrl);

    const purchaseDetails = await HeaderApi.fetchHeaderWithAuth(
      'purchase/details'
    );

    const { vehicleId } = purchaseDetails || {};
    const isReserved = purchaseDetails?.orderState === 'Reserved' && vehicleId;
    const isActivePurchase = !isReserved && vehicleId;

    if (isReserved) {
      return redirectOnLogin(`/vehicle/${vehicleId}`);
    }

    if (isActivePurchase) {
      return redirectOnLogin(
        `/purchase/dashboard?stock-number=${purchaseDetails.stockNumber}`
      );
    }

    const postSaleDetails = await HeaderApi.fetchHeaderWithAuthV2(
      'postsale/details'
    );

    if (postSaleDetails?.IsUserInPostSale) {
      return redirectOnLogin('/post-sale-dashboard');
    }

    return refreshHeader();
  } catch (error) {
    throw error;
  }
};
